module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('i', [_vm._v("Dedicated to the One True Sovereign")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "dedi1"
  }, [_c('i', [_vm._v("To serve as a visual reminder of the consequences when")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('i', [_vm._v("mankind persists in a course of rebellion against His rulership")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-856d207c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Decication.vue
// module id = 66
// module chunks = 0